import { Platform } from '@cart-services/hooks/fp-b2b/store-map'
import { useFpB2bCartService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-service'
import { ScrollableList } from '../../../../components/ScrollableList/ScrollableList'
import { type BrandInfo } from '../../constants'
import { useStmBrandStore } from '../../hooks'
import { BrandChipCompact } from './BrandChipCompact'

const CartCountSubtitle = ({ campaignId }: { campaignId: number }) => {
  const { cartItemTotalQuantity } = useFpB2bCartService(campaignId, Platform.STM)
  if (!cartItemTotalQuantity) return null
  return <>{`${cartItemTotalQuantity} 件待結帳`}</>
}

export interface BrandCompactSelectorProps {
  showCartCount?: boolean
}

export const BrandCompactSelector = ({ showCartCount }: BrandCompactSelectorProps) => {
  const { currentBrand, brands, setBrand } = useStmBrandStore()

  const handleSelect = (brand: BrandInfo) => {
    setBrand(brand.campaignCode)
  }

  return (
    <ScrollableList>
      {brands.map(brand => (
        <BrandChipCompact
          key={brand.campaignCode}
          brand={brand}
          selected={brand.campaignCode === currentBrand?.campaignCode}
          subtitle={showCartCount ? <CartCountSubtitle campaignId={brand.campaignId} /> : undefined}
          onClick={handleSelect}
        />
      ))}
    </ScrollableList>
  )
}
